<template>
  <div class="mt-4 px-4 container-fluid">
    <div class="breadcrumb text-md px-0 mb-4">
      <p><span class="breadcrumb-item" @click="$router.push({ name: 'Dashboard' })" style="cursor:pointer">Inicio</span> > Pasarelas</p>
    </div>
  </div>

  <!-- ── FORMULARIO (alta / editar) ────────────── -->
  <div v-if="vistaActual !== 'lista'" class="px-4 container-fluid mb-4">
    <PasarelaForm
      :modo="vistaActual"
      :pasarela="pasarelaEditando"
      :tipsters="tipsters"
      :tipsterIdFijo="tipsterIdFijo"
      @guardada="onGuardada"
      @cancelar="volverALista"
    />
  </div>

  <!-- ── LISTADO ────────────────────────────────── -->
  <template v-else>
    <div class="px-4 container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="card ficha-buscador">
            <div class="titulo">
              <h5 class="mx-4 mt-5 mb-5">Listado de pasarelas</h5>
            </div>
            <div class="table-search">
              <input id="buscadorPasarelas" type="text" class="form-control" placeholder="Búsqueda rápida por nombre o slug..." aria-label="Buscar pasarela" @input="teclearBuscador" />
            </div>
            <div v-if="canCrear" class="descarga">
              <p @click="abrirAlta" title="Nueva pasarela"><i class="fa fa-plus" aria-hidden="true"></i></p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Filtros secundarios -->
    <div class="px-4 container-fluid mt-2">
      <div class="d-flex gap-2 flex-wrap align-items-center">
        <select v-model="filtroEstado" class="form-select form-select-sm" style="max-width: 160px" @change="fetchLista">
          <option value="">Todos los estados</option>
          <option value="borrador">Borrador</option>
          <option value="activa">Activa</option>
          <option value="inactiva">Inactiva</option>
        </select>
        <select v-if="esAdmin" v-model="filtroTipster" class="form-select form-select-sm" style="max-width: 220px" @change="fetchLista">
          <option value="">Todos los tipsters</option>
          <option v-for="t in tipsters" :key="t.id" :value="t.id">{{ t.nombre }}</option>
        </select>
      </div>
    </div>

    <div class="px-4 container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="card ficha-listado mt-4">
            <div class="px-4 pb-0 card-body">
              <div class="table-responsive mb-4">

                <div v-if="error" class="alert alert-danger py-2">{{ error }}</div>
                <div v-if="cargando" class="text-center py-4 text-muted">Cargando...</div>

                <table v-else class="table table-flush table-listado">
                  <thead class="thead-light">
                    <tr>
                      <th class="sin-orden">Nombre</th>
                      <th v-if="esAdmin" class="sin-orden">Tipster</th>
                      <th class="sin-orden">Slug</th>
                      <th class="sin-orden">Productos</th>
                      <th class="sin-orden">Tema</th>
                      <th class="sin-orden">Estado</th>
                      <th class="sin-orden">Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="lista.length === 0">
                      <td :colspan="esAdmin ? 7 : 6" class="text-center text-muted py-4">Sin pasarelas</td>
                    </tr>
                    <tr v-for="p in lista" :key="p.id" :data-id="p.id">
                      <td class="text-sm font-weight-bold">{{ p.nombre }}</td>
                      <td v-if="esAdmin" class="text-sm">{{ p.tipster }}</td>
                      <td class="text-sm text-muted">{{ p.slug }}</td>
                      <td class="text-sm text-center">{{ p.num_productos }}</td>
                      <td class="text-sm">
                        <span class="badge-q" :class="temaBadgeClass(p.tema_visual)">{{ p.tema_visual }}</span>
                      </td>
                      <td class="text-sm">
                        <span class="badge-q" :class="estadoBadgeClass(p.estado)">{{ p.estado }}</span>
                      </td>
                      <td>
                        <a :href="p.url_publica" target="_blank" rel="noopener noreferrer" title="Ver pasarela pública" class="me-2">
                          <i class="fas fa-external-link-alt text-secondary"></i>
                        </a>
                        <i class="fas fa-clipboard text-secondary me-2 cursor-pointer" title="Copiar URL" @click="copiarUrl(p.url_publica)"></i>
                        <i v-if="canEditar" class="fas fa-edit text-secondary me-2 cursor-pointer" title="Editar" @click="abrirEditar(p)"></i>
                        <i v-if="canEliminar" class="fas fa-trash text-secondary cursor-pointer" title="Eliminar" @click="confirmarEliminar(p)"></i>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <!-- Paginación -->
                <div v-if="paginas > 1" class="d-flex justify-content-center gap-2 mt-3">
                  <button class="btn btn-sm btn-outline-secondary mb-0" :disabled="pagina <= 1" @click="cambiarPagina(pagina - 1)">‹</button>
                  <span class="align-self-center text-sm">{{ pagina }} / {{ paginas }}</span>
                  <button class="btn btn-sm btn-outline-secondary mb-0" :disabled="pagina >= paginas" @click="cambiarPagina(pagina + 1)">›</button>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>

  <!-- Modal confirmación eliminar -->
  <div v-if="pasarelaAEliminar" class="modal-overlay" @click.self="pasarelaAEliminar = null">
    <div class="modal-box card p-4">
      <h6>¿Eliminar pasarela?</h6>
      <p class="text-sm mb-3">Se eliminará "<strong>{{ pasarelaAEliminar.nombre }}</strong>". Esta acción no se puede deshacer.</p>
      <div class="d-flex gap-2 justify-content-end">
        <button class="btn btn-secondary btn-sm mb-0" @click="pasarelaAEliminar = null">Cancelar</button>
        <button class="btn btn-danger btn-sm mb-0" :disabled="eliminando" @click="ejecutarEliminar">
          {{ eliminando ? "Eliminando..." : "Eliminar" }}
        </button>
      </div>
    </div>
  </div>

</template>

<script>
import PasarelaForm from "./components/pasarelas/PasarelaForm.vue";
import { listarPasarelas, eliminarPasarela, detallePasarela } from "@/services/pasarelas.service.js";

export default {
  name: "Pasarelas",
  components: { PasarelaForm },
  data() {
    return {
      vistaActual: "lista",
      lista: [],
      tipsters: [],
      pasarelaEditando: null,
      pasarelaAEliminar: null,
      buscar: "",
      filtroEstado: "",
      filtroTipster: "",
      pagina: 1,
      paginas: 1,
      cargando: false,
      eliminando: false,
      error: null,
    };
  },
  computed: {
    esAdmin() {
      return this.$store.getters["auth/rolEfectivo"] === 1;
    },
    permisos() {
      return this.$store.state.auth?.permisos_finales || [];
    },
    canCrear() {
      return this.permisos.includes("pasarelas.crear");
    },
    canEditar() {
      return this.permisos.includes("pasarelas.editar");
    },
    canEliminar() {
      return this.permisos.includes("pasarelas.eliminar");
    },
    tipsterIdFijo() {
      if (this.esAdmin) return null;
      return this.$store.state.auth?.me?.data?.attributes?.tipster_id || null;
    },
  },
  mounted() {
    this.cargarTipsters();
    this.fetchLista();
  },
  methods: {
    async cargarTipsters() {
      if (!this.esAdmin) return;
      try {
        const data = await this.$store.dispatch("auth/listaTipsters");
        this.tipsters = Array.isArray(data) ? data : [];
      } catch {
        this.tipsters = [];
      }
    },

    teclearBuscador(e) {
      this.buscar = e.target.value;
      clearTimeout(this._buscarTimer);
      this._buscarTimer = setTimeout(() => {
        this.pagina = 1;
        this.fetchLista();
      }, 350);
    },

    async fetchLista() {
      this.cargando = true;
      this.error = null;
      try {
        const payload = {
          pagina: this.pagina,
          buscar: this.buscar || undefined,
          estado: this.filtroEstado || undefined,
          tipster_id: this.filtroTipster || undefined,
        };
        const res = await listarPasarelas(payload);
        this.lista   = res.data?.data ?? [];
        this.paginas = res.data?.paginas ?? 1;
      } catch {
        this.error = "Error al cargar las pasarelas.";
      } finally {
        this.cargando = false;
      }
    },

    cambiarPagina(n) {
      this.pagina = n;
      this.fetchLista();
    },

    abrirAlta() {
      this.pasarelaEditando = null;
      this.vistaActual = "alta";
    },

    async abrirEditar(pasarela) {
      try {
        const res = await detallePasarela(pasarela.id);
        this.pasarelaEditando = res.data?.pasarela ?? pasarela;
      } catch {
        this.pasarelaEditando = pasarela;
      }
      this.vistaActual = "editar";
    },

    volverALista() {
      this.vistaActual = "lista";
      this.pasarelaEditando = null;
    },

    onGuardada() {
      this.volverALista();
      this.fetchLista();
    },

    confirmarEliminar(p) {
      this.pasarelaAEliminar = p;
    },

    async ejecutarEliminar() {
      if (!this.pasarelaAEliminar) return;
      this.eliminando = true;
      try {
        await eliminarPasarela(this.pasarelaAEliminar.id);
        this.pasarelaAEliminar = null;
        this.fetchLista();
      } catch {
        this.error = "Error al eliminar la pasarela.";
        this.pasarelaAEliminar = null;
      } finally {
        this.eliminando = false;
      }
    },

    estadoBadgeClass(estado) {
      if (estado === "activa")   return "badge-q--activa";
      if (estado === "borrador") return "badge-q--borrador";
      return "badge-q--neutro";
    },

    temaBadgeClass(tema) {
      const map = {
        verde_pro:       "badge-q--verde",
        dark_premium:    "badge-q--dark",
        azul_quanty:     "badge-q--azul",
        claro_deportivo: "badge-q--claro",
        rojo_energia:    "badge-q--rojo",
        violeta_vip:     "badge-q--violeta",
      };
      return map[tema] || "badge-q--neutro";
    },

    copiarUrl(url) {
      navigator.clipboard.writeText(url || "").catch(() => {});
    },
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
}
.modal-box {
  max-width: 420px;
  width: 90%;
}

/* Elimina la doble flecha en selects (Bootstrap + nativo) */
select.form-select,
select.form-control {
  background-image: none !important;
  -webkit-appearance: menulist !important;
  -moz-appearance: menulist !important;
  appearance: menulist !important;
  padding-right: 0.75rem !important;
}

table td,
table th {
  border: none !important;
  border-radius: 0 !important;
}
table th::after {
  display: none !important;
  content: none !important;
  width: 0 !important;
  height: 0 !important;
}
table thead th {
  border-bottom: 1px solid var(--q-border) !important;
}
table tbody tr:not(:last-child) td {
  border-bottom: 1px solid var(--q-border) !important;
}

/* ── Badges design system ─────────────────────── */
.badge-q {
  display: inline-block;
  padding: 2px 10px;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 700;
  white-space: nowrap;
  border: 1px solid transparent;
}
.badge-q--activa   { background: var(--q-green-soft);  border-color: var(--q-green);  color: var(--q-green); }
.badge-q--borrador { background: var(--q-amber-soft);  border-color: var(--q-amber);  color: var(--q-amber); }
.badge-q--neutro   { background: var(--q-hover);       border-color: var(--q-border-md); color: var(--q-muted); }
.badge-q--verde    { background: var(--q-green-soft);  border-color: var(--q-green);  color: var(--q-green); }
.badge-q--rojo     { background: var(--q-red-soft);    border-color: var(--q-red);    color: var(--q-red); }
.badge-q--azul     { background: #0a1e33; border-color: #3b82f6; color: #60a5fa; }
.badge-q--violeta  { background: #1a0d2e; border-color: #8b5cf6; color: #a78bfa; }
.badge-q--dark     { background: var(--q-hover);       border-color: var(--q-border-md); color: var(--q-muted); }
.badge-q--claro    { background: var(--q-amber-soft);  border-color: var(--q-amber);  color: var(--q-amber); }
</style>
